export class StringService {
  static clearString(value) {
    return value
      .toLowerCase()
      .replace(/[\d]/gi, '') // limpa números
      .replace(/[^a-z\s]/gi, ''); // limpa o que não for letras
  }

  static formatTitle(value) {
    let prefix = 'Auto Captura - ';

    return prefix + value;
  }
}
